export default {
  isLoading: false,
  isOpenModalEliminar: false,
  isOpenModalEditar: false,
  isOpenModalDesactivar: false,
  batery: {},
  isNewBatery: false,
  listaBaterias: [],
  listaBateriasFiltradas: [],
  filtrosBaterias: null,
  listaPrestaciones: [],
};
